import { TwitterFeed } from 'ui/components';

export const TwitterFeedFeature: React.FC<Content.Linkbox> = () => {
	return <TwitterFeed />;
};
